exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dashboard-quick-forms .cont-dash{max-width:1400px}.dashboard-quick-forms .dashboard-forms-content-bottom,.dashboard-quick-forms .dashboard-forms-content-top{padding:0 20px 0 25px;margin:0}.dashboard-quick-forms a.new-form-button{width:150px;min-height:45px;text-align:center;text-indent:16px;padding:13px 0 0 20px;display:inline-block;vertical-align:middle;font-weight:600;color:#d22630;border:2px solid #d22630;border-radius:2px;position:relative;margin-right:80px;background-image:url(" + require("./plus.svg") + ");background-size:25px;background-position:left 12px center;transition:all .3s ease-in-out;background-repeat:no-repeat;background-color:#fff}.dashboard-quick-forms a.new-form-button:hover{background-color:#d22630;color:#fff;background-image:url(" + require("./../../../images/new-form-white.svg") + ")}.dashboard-quick-forms a.new-form-button img{position:absolute;left:19px;top:11px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/dashboard/forms/forms.scss
// module id = 718
// module chunks = 0